export default "__VITE_ASSET__C6psQw5i__"